export default class MathUtils {
  static normalizeValue(value: number, min?: number, max?: number): number {
    if (min !== undefined && max !== undefined) {
      return Math.min(Math.max(min, value), max); // If min and max are provided
    }

    return value;
  }
}
